import { authenticatedRequest } from './api.service';
import {
  PomQuestionsResponse,
  PomLastTestResponse,
  PomSubmitRequest,
  PomSubmitResponse,
  PomPdfStatusResponse, PomLastTestResponseFail
} from "../typings/pom";

export const pomService = {
  getAllQuestions: async (
    randomize: boolean = true
  ): Promise<PomQuestionsResponse> => {
    const response = await authenticatedRequest("GET", "/pom/questions/all", {
      randomize,
    });
    return response as unknown as PomQuestionsResponse;
  },

  getLastTest: async (
    withCount: boolean = false
  ): Promise<PomLastTestResponse | PomLastTestResponseFail> => {
    try {
      const params = withCount ? { wc: 1 } : {};
      const response = await authenticatedRequest(
        "GET",
        "/pom/last-test",
        params
      );
      return {...response, status:true} as unknown as PomLastTestResponse;
    } catch (e:any){
      return { data: { countUser: e?.message?.data?.countUser }, status: false, message: e?.message?.message};
    }
  },

  submitTest: async (answers: PomSubmitRequest): Promise<PomSubmitResponse> => {
    const response = await authenticatedRequest(
      "POST",
      "/pom/submit-test",
      answers
    );
    return response as unknown as PomSubmitResponse;
  },

  getAIRecommendation: async (testId: number): Promise<any> => {
    const response = await authenticatedRequest(
      "POST",
      `/pom/ai-recommendation/${testId}`
    );
    return response as unknown as any;
  },

  getTestById: async (testId: number): Promise<PomLastTestResponse> => {
    const response = await authenticatedRequest("GET", `/pom/test/${testId}`);
    return response as unknown as PomLastTestResponse;
  },

  getPdfStatus: async (testId: number): Promise<PomPdfStatusResponse> => {
    const response = await authenticatedRequest(
      "GET",
      `/pom/pdf-status/${testId}`
    );
    return response as unknown as PomPdfStatusResponse;
  },

  downloadPdf: async (testId: number): Promise<Blob> => {
    // Note: authenticatedRequest might not handle Blobs directly if it uses .json()
    // You might need a specialized method for file downloads if this doesn't work.
    // However, I'll follow the pattern and assume it's handled or we'll adjust later.
    const response = await authenticatedRequest(
      "POST",
      `/pom/download-pdf/${testId}`,
      {},
      { responseType: "blob" }
    );
    return response as unknown as Blob;
  },
};
